import request from '@/utils/request2'

// 登录
export function login(params) {
  return request({
    url:'/app/LLZadminApi',
    method:'POST',
    data:params
  })
}

// 用户权限列表
export function getInfo(params) {
  return request({
    url:'/app/LLZadminApi',
    method:'get',
    params:params
  })
}

// 退出
export function logout(params) {
  return request({
    url:'/app/LLZadminApi',
    method:'get',
    params:params
  })
}

// 登录用户修改自己的信息
export function updateUserInfo(params) {
  return request({
    url:'/app/LLZadminApi',
    method:'POST',
    data:params
  })
}

// 获取所有菜单列表
export function getMenuList(params) {
  return request({
    url:'/app/LLZadminApi',
    method:'get',
    params:params
  })
}

// 新建菜单
export function createOrUpdate(params) {
  return request({
    url:'/app/LLZadminApi',
    method:'POST',
    data:params
  })
}

//删除菜单
export function deleteMenu(params) {
  return request({
    url:'/app/LLZadminApi',
    method:'get',
    params:params
  })
}

// 管理员列表
export function adminUserList(params) {
  return request({
    url:'/app/LLZadminApi',
    method:'get',
    params:params
  })
}

// 权限列表
export function adminRoleslist(params) {
  return request({
    url:'/app/LLZadminApi',
    method:'get',
    params:params
  })
}

// 管理员详情
export function adminInfo(params) {
  return request({
    url:'/app/LLZadminApi',
    method:'get',
    params:params
  })
}

// 添加or更改管理员信息
export function createOrUpdateAdmin(params) {
  return request({
    url:'/app/LLZadminApi',
    method:'POST',
    data:params
  })
}

// 删除管理员
export function deleteAdminUser(params) {
  return request({
    url:'/app/LLZadminApi',
    method:'get',
    params:params
  })
}

// 用户列表
export function userList(params) {
  return request({
    url:'/app/LLZadminApi',
    method:'get',
    params:params
  })
}

// 用户详情
export function userDetail(params) {
  return request({
    url:'/app/LLZadminApi',
    method:'get',
    params:params
  })
}

// 添加/编辑用户
export function createUser(params) {
  return request({
    url:'/app/LLZadminApi',
    method:'get',
    params:params
  })
}

// 黑白名单/重置下单数
export function updateUpperLimit(params) {
  return request({
    url:'/app/LLZadminApi',
    method:'get',
    params:params
  })
}

// 用户风控报告
export function queryriskUser(params) {
  return request({
    url:'/app/LLZadminApi',
    method:'get',
    params:params
  })
}


// WEBPACK FOOTER //
// ./src/api2/user.js